<div class="modal-overlay">
  <div class="card mx-auto modal-lg border-0">
    <div class="card-header bergh-bg-primary text-white h5">
      Plattegronden aanpassen
    </div>

    <div class="card-body">
      @if (type !== 'Project Details') {
      <div class="row">
        <div class="col-12">
          <div class="form-group header">
            <h6>Nieuwe plattegronden uploaden</h6>
          </div>
        </div>
        <div class="col-12 px-0">
          <div class="form-group">
            <div class="btn btn-mdb-color btn-rounded float-left col-12">
              <div class="input-group file-upload">
                <input
                  type="file"
                  class="file-upload-btn form-control"
                  title="kies afbeelding om te uploaden"
                  (change)="onUploadSelectFile($event)"
                  accept="image/png,image/jpg,image/jpeg,application/pdf,.dwg"
                />
                <input
                  type="text"
                  autocomplete="off"
                  aria-autocomplete="none"
                  class="form-control file-upload-file"
                  id="in-file"
                  placeholder="Zet het bestand hier neer of klik om het bestand te selecteren"
                  [value]="uploadFileName"
                />
              </div>
              <small class="text-danger float-left"
                >Opmerking: de bestandsgrootte moet kleiner zijn dan 15
                MB</small
              >
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="ml-auto">
            <span class="input-group-append">
              <span
                class="heading-span btn bergh-btn-secondary text-white ml-auto d-flex align-items-center"
                id="btn_upload"
                (click)="uploadMap()"
              >
                <i-feather name="upload" class="small-icon mr-2"></i-feather
                >Uploaden
              </span>
            </span>
          </div>
        </div>
      </div>
      }
      <br />
      @if (loading) {
      <bergh-loader></bergh-loader>
      }
      <div class="row">
        <div class="col-12">
          <div class="form-group header">
            <h6>Geüploade plattegronden</h6>
          </div>
        </div>
        @if (mapList.length <= 0) {
        <div class="col-12">
          <div class="alert alert-primary bergh-text-primary text-center">
            Geen data gevonden
          </div>
        </div>
        } @if (mapList.length > 0) {
        <div class="col-12">
          <table class="table border bg-white">
            <thead>
              <tr>
                <th scope="col">S.No</th>
                <th scope="col" class="text-small text-truncate">
                  Bestandsnaam
                </th>
                @if (isShow) {
                <th scope="col" class="actions">Actie</th>
                }
              </tr>
            </thead>
            <tbody>
              @for (data of mapList; track data; let i = $index) {
              <tr>
                <td>
                  <div class="d-flex">
                    {{ i + 1 }}
                  </div>
                </td>
                <td class="fileName text-small text-truncate">
                  <div class="d-flex">
                    {{ data.name }}
                  </div>
                  <div class="d-none inputFileName" #cancel>
                    @if (isEdit) {
                    <div class="form-group col-8 p-0">
                      <input
                        type="text"
                        class="form-control"
                        [(ngModel)]="selectedFile"
                        value="{{ data.name }}"
                        id="in-file-{{ i }}"
                      />
                    </div>
                    }
                    <button
                      class="mb-3"
                      class="btn btn-danger mb-3 ml-2"
                      id="btn-close"
                      (click)="cancelInput(cancel)"
                    >
                      <i-feather name="x" class="small-icon"></i-feather>
                    </button>
                    @if (isEdit) {
                    <button
                      class="btn btn-success mb-3 ml-2"
                      id="btn_editFileName"
                      (click)="editMap(data)"
                    >
                      <i-feather name="check" class="small-icon"></i-feather>
                    </button>
                    }
                  </div>
                </td>
                @if (isShow) {
                <td class="btn-delete btn-clc">
                  <div class="d-flex">
                    <div
                      class="btn bergh-btn-secondary text-white"
                      title="Bewerken"
                      id="btn_edit"
                      (click)="editImageName(show, data, 'EDIT')"
                      #show
                    >
                      <i-feather name="edit" class="small-icon"></i-feather>
                    </div>
                    <button
                      class="btn bergh-btn-secondary text-white"
                      id="btn_replace"
                      title="Vervangen"
                      (click)="mapReplacementOperation(data)"
                      #show
                    >
                      <i-feather name="map" class="small-icon"></i-feather>
                    </button>
                    @if (isReplaceModalOpen) {
                    <div class="modal-overlay-map">
                      <div class="card mx-auto modal-xxl border-0">
                        <div class="card-header bergh-bg-primary text-white h5">
                          Kaartvervanging
                        </div>
                        <bergh-map-replacement-operation
                          [isReplace]="isReplace"
                          [oldMap]="mapData"
                          (cancel)="isReplaceModalOpen = false"
                          (updatedList)="getAllMapList()"
                        ></bergh-map-replacement-operation>
                      </div>
                    </div>
                    }
                    <button
                      class="btn bergh-btn-secondary text-white"
                      [disabled]="!data.prevMapName || loading"
                      title="Herstel vorige plattegrond"
                      id="btn_revert"
                      (click)="revertMapFile(data)"
                      #show
                    >
                      <i-feather
                        name="rotate-ccw"
                        class="small-icon"
                      ></i-feather>
                    </button>
                    <div
                      class="btn btn-sm btn-danger icon-btn"
                      #delete
                      (click)="openDelete(delete)"
                      id="btn_delete"
                    >
                      <i-feather name="trash-2" class="small-icon"></i-feather>
                    </div>
                    <div class="info-window bergh-shadow-one">
                      <p class="text-dark">
                        Weet je zeker dat je dit wilt verwijderen?<br />
                        Het kan niet worden opgehaald
                      </p>
                      <div class="btn-collection">
                        <button
                          class="btn btn-sm btn-secondary"
                          #no
                          type="button"
                          (click)="cancelDelete(no)"
                        >
                          Nee
                        </button>
                        <button
                          class="btn btn-sm btn-danger"
                          #yes
                          (click)="deleteMap(data); cancelDelete(yes)"
                          type="button"
                        >
                          Ja
                        </button>
                      </div>
                    </div>
                  </div>
                </td>
                }
              </tr>
              }
            </tbody>
          </table>
        </div>
        }
      </div>
    </div>
    <div class="card-footer bg-white d-flex justify-content-end">
      <button
        class="btn btn-secondary mr-2"
        (click)="cancel.emit()"
        id="btn-cancel"
      >
        Sluiten
      </button>
    </div>
  </div>
</div>
